import { useAuth } from "@/context/AuthContext";
import { Navigate, Outlet } from "react-router-dom";
import AppLayout from "@/components/AppLayout";

export default function ProtectedRoute({ adminOnly = false, superadminOnly = false }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-dd-blue" data-testid="auth-loading">
        Chargement…
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (superadminOnly && user.role !== "superadmin") return <Navigate to="/constats" replace />;
  if (!superadminOnly && user.role === "superadmin" && !user.support_readonly) return <Navigate to="/master" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/constats" replace />;
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
